import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomInput from "../../Core/Components/CustomInput";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import FilterItem from "../../Core/Components/FilterItem";
import Button from "../../Core/Components/CustomButton";
import useHeaderItems from "./useHeaderItems";
import { requestTypeFilters, ussdStatusFilters } from "./Ussd/data";
import { rentalStatusFilters } from "./Rentals/data";

const Header = ({ search, setSearch, filters, setFilters, setCurrentPage }) => {
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  const { allHubs } = useSelector((state) => state.locations);

  const headerButtons = useHeaderItems().filter((item) => item.hasPermission);

  const selectedTab = searchParams.get("tab");

  // get all the hubs
  const hubFilters = allHubs.map((hub) => ({
    id: hub?.id,
    value: hub?.name,
  }));

  const [focus, setFocus] = useState(false);

  const getPlaceholder = () => {
    if (focus) return null;
    if (selectedTab === "ussd") return "Search Farmers";
    if (selectedTab === "rentals") return "Search Drivers";
    return "Search";
  };

  const onTabClick = (item) => {
    const option = item.text.toLowerCase();
    searchParams.set("tab", option);
    setSearchParams(searchParams);
    navigate(`/requests?tab=${option}`);
  };

  const onSelect = (key, value) => {
    // whenever applying the filter, the page should be defaulted back to first page
    setCurrentPage(1);

    if (filters[key].includes(value)) {
      const newFilters = filters[key].filter((item) => item !== value);
      setFilters({ ...filters, [key]: newFilters });
    } else {
      setFilters({ ...filters, [key]: [...filters[key], value] });
    }
  };

  return (
    <div className="bg-background-white px-6 py-3.5 flex items-center justify-between border-b">
      <div className="flex items-center gap-x-6">
        {headerButtons.map((item) => {
          const selected = selectedTab === item.text.toLowerCase();

          return (
            <Button
              key={item.id}
              colors={selected ? "primary" : "white"}
              width={item.width}
              padding={item.padding}
              modifier="shadow"
              onClick={() => onTabClick(item)}
            >
              <div>{item.text}</div>
            </Button>
          );
        })}
      </div>

      <div className="flex items-center gap-x-3">
        <CustomInput
          intent="search"
          prefix={
            <img src="/assets/icons/search.svg" alt="" className="mr-2" />
          }
          value={search}
          focus={focus}
          border={focus ? "success" : "none"}
          placeholder={getPlaceholder()}
          onChange={(e) => setSearch(e.target.value)}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          suffix={
            search.length > 0 ? (
              <CloseIcon
                className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
                onClick={() => {
                  setFocus(false);
                  setSearch("");
                }}
              />
            ) : null
          }
        />

        <FilterItem
          label="Hub Station"
          identifier="hub"
          contentData={hubFilters}
          onSelect={onSelect}
          selectedValues={filters.hub}
          className="max-h-[200px] overflow-y-scroll"
          enableSearch
        />

        {selectedTab === "ussd" && (
          <FilterItem
            label="Request Type"
            identifier="type"
            className="max-h-[200px] overflow-y-scroll"
            customValue
            contentData={requestTypeFilters}
            onSelect={onSelect}
            selectedValues={filters.type}
          />
        )}

        <FilterItem
          label="Status"
          identifier="status"
          className="max-h-[250px] overflow-y-scroll"
          customValue
          onSelect={onSelect}
          selectedValues={filters.status}
          contentData={
            selectedTab === "ussd" ? ussdStatusFilters : rentalStatusFilters
          }
        />
      </div>
    </div>
  );
};

export default Header;
